import { CallbackFieldType } from '../interfaces/journey.interface';
import { CallbackTypeStrategy } from './callback-type-strategy';
import { DEFAULT_CALLBACK_TYPE_STRATEGIES } from './default-callback-type-strategies';

export class CallbackTypeRegistry {
  constructor(private readonly strategies: CallbackTypeStrategy[]) {}

  resolve(callbackType: string): CallbackFieldType | null {
    const strategy = this.strategies.find((item) => item.supports(callbackType));
    return strategy ? strategy.resolveFieldType() : null;
  }

  isSupported(callbackType: string): boolean {
    return this.resolve(callbackType) !== null;
  }
}

export const callbackTypeRegistry = new CallbackTypeRegistry(DEFAULT_CALLBACK_TYPE_STRATEGIES);
